// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__t6prd","Success":"Button_Success__1vcvn","Danger":"Button_Danger__WKwwG"};